<template>
    <el-dialog title="集团项目管理" :visible="showflag" :width="width" @close="closeDialog" :close-on-click-modal="false">
        <div class="mainBody">
            <div class="searchBox">
                <el-button type="primary"  @click="addItem">添加项目</el-button>
            </div>
            <div class="mainBody">
                <div class="dataBox">
                    <el-table :data="list" border stripe>
                        <el-table-column prop="project_name" label="项目名称"></el-table-column>
                        <el-table-column prop="group_name" label="集团名称"></el-table-column>
                        <el-table-column label="操作" width="80" align="center">
                            <template slot-scope="scope">
                                <el-button  size="mini" plain type="primary" @click="deleteItem(scope.row.id)">删除</el-button>
                            </template>
                        </el-table-column>
                    </el-table>
                </div>
            </div>
        </div>
        <div slot="footer" class="dialog-footer">
            <el-button type="primary" @click="closeDialog" size="medium">关 闭</el-button>
        </div>
        <ItemEdit
            width="600px"
            :group_id="group_id"
            title="添加项目"
            :isshow="addshow"
            @on-close="closeEditDialog"
            @on-save-ok="saveOk">
        </ItemEdit>
    </el-dialog>
</template>

<script>
import ItemEdit from "./itemedit"
import { groupItemList, delGroupItem } from '@/api/projectgroup.js'

export default {
    name: 'projectGroupItemList',
    components: {ItemEdit},
    props: {
        isshow: {
            type: Boolean,
            default() {
                return false;
            }
        },
        group_id: {
            type: Number,
            default() {
                return -1;
            }
        },
        width: {
            type: String,
            default() {
                return '800px';
            }
        }
    },
    watch: {
        isshow(newv, old) {
            this.showflag = newv;
            if (newv) {
                this.getItemList()
            }
        }
    },
    data() {
        return {
            m_name: '集团项目',
            menu_id: 9999,
            search_Obj: {
                f_xxxname: '',
            },
            enu_name: [],
            showflag: false,
            addshow: false,
            list: [],
        };
    },
    methods: {
        getItemList(){
            this.list = [];
            groupItemList(this.group_id).then(res=>{
                if(res.code ==1){
                    this.list = res.data
                }else{
                    this.$msg(res.msg)
                }
            })
        },
        addItem(){
            this.addshow = true
        },
        deleteItem(id){
            this.$confirm('确定要删除该工程吗?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                delGroupItem(id).then(res=>{
                    if(res.code == 1){
                        this.$msgs(res.msg)
                        this.getItemList()
                    }else{
                        this.$msg(res.msg)
                    }
                })
            }).catch(() => { })
        },
        saveOk(){
            this.addshow = false
            this.getItemList()
        },
        closeDialog() {
            this.$emit("on-close")
        },
        closeEditDialog(){
            this.addshow = false
        },
    }
};
</script>